module.exports = __webpack_public_path__ + "static/media/question-circle.f9b6ec38.svg";